import { PropAsset } from './PropAsset';

// Sign - Tabela
// TODO: Replace with SVG asset
export class Sign extends PropAsset {
  readonly id = 'sign';
  readonly width = 42;
  readonly height = 56;
  readonly walkable = true;  // Thin post, can walk past
  readonly collisionRadius = 0;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.1)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 6 * s, 3 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Post - Direk
    ctx.fillStyle = '#4a3628';
    ctx.fillRect(cx - 2 * s, cy - 32 * s, 4 * s, 32 * s);

    // Sign board - Tabela
    ctx.fillStyle = '#6b5335';
    ctx.fillRect(cx - 14 * s, cy - 30 * s, 28 * s, 14 * s);

    // Board border
    ctx.strokeStyle = '#4a3020';
    ctx.lineWidth = 1 * s;
    ctx.strokeRect(cx - 14 * s, cy - 30 * s, 28 * s, 14 * s);

    // Arrow pointing right - Sağa ok
    ctx.fillStyle = '#3a2618';
    ctx.beginPath();
    ctx.moveTo(cx + 10 * s, cy - 23 * s);
    ctx.lineTo(cx + 4 * s, cy - 26 * s);
    ctx.lineTo(cx + 4 * s, cy - 20 * s);
    ctx.closePath();
    ctx.fill();

    // Arrow line
    ctx.strokeStyle = '#3a2618';
    ctx.lineWidth = 2 * s;
    ctx.beginPath();
    ctx.moveTo(cx - 8 * s, cy - 23 * s);
    ctx.lineTo(cx + 4 * s, cy - 23 * s);
    ctx.stroke();

    // Nails
    ctx.fillStyle = '#4a4a4a';
    ctx.beginPath();
    ctx.arc(cx - 12 * s, cy - 28 * s, 1 * s, 0, Math.PI * 2);
    ctx.arc(cx + 12 * s, cy - 28 * s, 1 * s, 0, Math.PI * 2);
    ctx.arc(cx - 12 * s, cy - 18 * s, 1 * s, 0, Math.PI * 2);
    ctx.arc(cx + 12 * s, cy - 18 * s, 1 * s, 0, Math.PI * 2);
    ctx.fill();
  }
}
